// Cobrain's two lines on a thread (REQ-2026-10-07-167; module 04 B2355), on the company record's Conversations and at
// the head of the thread page. Mike by pop-up, 7 Oct 2026, "Cobrain's summary (Recommended)": "Two lines written by
// Cobrain per thread: where it stands and what is owed. Written once and again when a new message lands." A summary
// written before the thread's newest message says so, with that message's day (in UTC, as the record's own days are).
import { dayMonth } from '../day.js';

export interface ThreadSummary { stands: string; owed: string | null; asOf: string; fresh: boolean }

/** "Written before the newest message" with the day it was written at, for a summary a newer message has overtaken. Pure. */
export function staleWords(s: Pick<ThreadSummary, 'fresh' | 'asOf'>): string | null {
  return s.fresh ? null : `Written at the message of ${dayMonth(new Date(s.asOf), 'utc')}, before the newest.`;
}

export function SummaryLines({ summary, className }: { summary: ThreadSummary | null | undefined; className?: string }) {
  if (!summary) return null;
  const stale = staleWords(summary);
  return (
    <span className={`thread-sum${className ? ` ${className}` : ''}`}>
      <span className="thread-sum-line"><b>Where it stands: </b>{summary.stands}</span>
      <span className="thread-sum-line"><b>What is owed: </b>{summary.owed ?? 'Nothing, on either side.'}</span>
      {stale ? <span className="thread-sum-stale">{stale}</span> : null}
    </span>
  );
}
